<i18n src="./i18n/index.json"></i18n>

 <template>
  <div class="homepage-wrapper">
    <!--<h1>{{ $t('title') }}</h1>-->
    <div class="holder">
      <div class="panel-left">
        <div class="form-group">
          <label>{{ $t('waste_label') }}</label>
          <select class="form-control" v-model="selectedWaste" @change="setWasteType">
            <option
              v-for="waste in wasteList"
              :value="waste.atik_id">{{ waste.hammadde }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>{{ $t('amount_label') }}</label>
          <div class="checkbox-holder mb-10">
            <div class="radio">
              <label for="selectedAmountType1">
                <input
                  type="radio"
                  name="selectedAmountType"
                  id="selectedAmountType1"
                  class="form-control"
                  value="Yıllık"
                  @change="selectedAnimalAmount = ''"
                  v-model="selectedAmountTimeType">
                <span></span>
                {{ $t('yearly') }}
              </label>
            </div>
            <div class="radio">
              <label for="selectedAmountType2">
                <input
                  type="radio"
                  name="selectedAmountType"
                  id="selectedAmountType2"
                  class="form-control"
                  value="Günlük"
                  @change="selectedAnimalAmount = ''"
                  v-model="selectedAmountTimeType">
                <span></span>
                {{ $t('daily') }}
              </label>
            </div>
          </div>
          <div class="checkbox-holder mb-20" v-if="selectedAmountTimeType !== ''">
            <div class="radio">
              <label for="selectedMassType1">
                <input
                  type="radio"
                  name="selectedMassType"
                  id="selectedMassType1"
                  class="form-control"
                  value="Ton"
                  @change="selectedAnimalAmount = ''"
                  v-model="selectedAmountMassType">
                <span></span>
                {{ $t('tonne') }}
              </label>
            </div>
            <div class="radio">
              <label for="selectedMassType2">
                <input
                  type="radio"
                  name="selectedMassType"
                  id="selectedMassType2"
                  class="form-control"
                  value="Kg"
                  @change="selectedAnimalAmount = ''"
                  v-model="selectedAmountMassType">
                <span></span>
                Kg
              </label>
            </div>
          </div>
          <div v-if="selectedAmountMassType !== ''">
            <p class="label-helper">{{ $t('enter_waste_amount') }}</p>
            <input
              type="number"
              class="form-control"
              v-model="selectedAmount">
          </div>
          <div v-if="selectedWasteType === 'Animal'" class="mt-20">
            <label>{{ $t('animal_amount') }}</label>
            <input
              type="number"
              class="form-control"
              @focus="resetOtherAmounts"
              v-model="selectedAnimalAmount">
          </div>
        </div>
        <button class="btn btn-full btn-blue" @click="addWasteToUserWasteList" :disabled="selectedAmount === '' && selectedAnimalAmount ===''">{{ $t('add') }}</button>

        <div class="user-waste-list" v-if="userWasteList.length">
          <h3>{{ $t('waste_list') }}</h3>
          <ul>
            <li v-for="(userWaste, index) in userWasteList" v-bind:style="{ backgroundColor: userWaste.color}">
              <span>
                <span class="name">{{ userWaste.hammadde }}</span>
                <em>{{ userWaste.miktar }} {{ userWaste.birim_kutle_2 }}/{{ userWaste.birim_zaman_2 }}</em>
              </span>
              <a href="javascript:;" @click="removeWaste(index)"> <img src="static/close.svg"></a>
            </li>
          </ul>
        </div>
        <!--<pre>{{userWasteList}}</pre>-->
      </div>
      <div class="content-area">
        <p class="text-center mb-20" v-if="visibleSection === 'description'">{{ $t('description') }}</p>
        <p class="text-center mb-20 alert-success" v-if="visibleSection === 'mailalert'">{{ $t('mail_alert') }}</p>
        <div class="container" v-if="visibleSection === 'form'">
          <p class="text-center mb-30">
            {{ $t('form_description_one') }}<br>
            <b>{{ $t('form_description_two') }}</b>
          </p>
          <form @submit.prevent="validateBeforeSubmit" class="lead-form">
            <div class="form-group">
              <label class="label">{{ $t('email_address') }}</label>
              <div>
                <input class="form-control" name="eposta" v-model="email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('eposta') }" type="text">
                <i v-show="errors.has('eposta')" class="fa fa-warning"></i>
                <span v-show="errors.has('eposta')" class="help is-danger">{{ errors.first('eposta') }}</span>
              </div>
            </div>
            <div class="form-group">
              <label class="label">{{ $t('name') }}</label>
              <div>
                <input class="form-control" name="isim" v-model="name" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('isim') }" type="text">
                <i v-show="errors.has('isim')" class="fa fa-warning"></i>
                <span v-show="errors.has('isim')" class="help is-danger">{{ errors.first('isim') }}</span>
              </div>
            </div>
              <div class="form-group">
              <label class="label">{{ $t('phone') }}</label>
              <div>
                <input class="form-control" name="telefon" v-model="phone" v-validate="'required|numeric'" :class="{'input': true, 'is-danger': errors.has('telefon') }" type="text">
                <i v-show="errors.has('telefon')" class="fa fa-warning"></i>
                <span v-show="errors.has('telefon')" class="help is-danger">{{ errors.first('telefon') }}</span>
              </div>
            </div>
              <button class="btn btn-full btn-blue" type="submit">{{ $t('send') }}</button>
          </form>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import VueApexCharts from 'vue-apexcharts'

  Vue.use(VueAxios, axios)

  export default {
    name: 'Home',
    components: {
      apexcharts: VueApexCharts
    },
    data () {
      return {
        wasteList: [],
        selectedWaste: '',
        selectedWasteType: '',
        selectedAmountTimeType: '',
        selectedAmountMassType: '',
        selectedAmount: '',
        selectedAnimalAmount: '',
        userWasteList: [],
        color: '#000000',
        methanePotential: 0,
        electricityGeneration: 0,
        installedCapacity: '',
        email: '',
        name: '',
        phone: '',
        visibleSection: 'description'
      }
    },
    mounted () {
      let formData = new FormData()

      formData.append('action', 'get_ajax_posts')
      Vue.axios.post('https://pales.com.tr/wp-admin/admin-ajax.php', formData).then((response) => {
        this.wasteList = response.data
      })

    },
    watch: {
      '$route' (to, from) {
      }
    },
    methods: {
      addWasteToUserWasteList () {
        this.generator()
        let item = this.wasteList.find(item => item.atik_id === this.selectedWaste)

        if(this.selectedAnimalAmount !== '') {
          item.miktar = (this.selectedAnimalAmount * item.atik_uretimi) * 365 / 1000
        }
        else {
          if(this.selectedAmountTimeType === 'Yıllık' && this.selectedAmountMassType === 'Ton') {
            item.miktar = this.selectedAmount
          }
          else if (this.selectedAmountTimeType === 'Yıllık' && this.selectedAmountMassType === 'Kg') {
            item.miktar = this.selectedAmount * 0.001
          }
          else if (this.selectedAmountTimeType === 'Günlük' && this.selectedAmountMassType === 'Ton') {
            item.miktar = this.selectedAmount * 365
          }
          else if (this.selectedAmountTimeType === 'Günlük' && this.selectedAmountMassType === 'Kg') {
            item.miktar = (this.selectedAmount * 365) / 1000
          }
        }
        item.color = this.color
        this.userWasteList.push(item)
        this.visibleSection = 'form'
      },
      generator: function (event) {
        this.color = '#' + (Math.random() * 0xFFFFFF << 0).toString(16)
      },
      removeWaste (wasteID) {
        this.userWasteList.splice(wasteID, 1)
        this.calculateProductionValues()
      },
      setWasteType() {
        let animalWasteList = ['66' , '67', '68', '69', '70', '71' , '72' , '73']
        if(animalWasteList.includes(this.selectedWaste)) {
          this.selectedWasteType = 'Animal'
        }
        else {
          this.selectedWasteType = 'Other'
        }
      },
      resetOtherAmounts () {
        this.selectedAmountTimeType = ''
        this.selectedAmountMassType = ''
        this.selectedAmount = ''
      },
      generateToken (length) {
        var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
        var b = [];
        for (var i=0; i<length; i++) {
          var j = (Math.random() * (a.length-1)).toFixed(0);
          b[i] = a[j];
        }
        return b.join("");
      },
      validateBeforeSubmit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            let userToken = this.generateToken(32)
            let formData = new FormData()

            let userData = {
              name: this.name,
              email: this.email,
              phone: this.phone,
              token: userToken,
              wasteList: this.userWasteList
            }

            formData.append('action', 'send_email')
            formData.append('name', this.name)
            formData.append('email', this.email)
            formData.append('phone', this.phone)
            formData.append('token', userToken)
            formData.append('userData', JSON.stringify(userData))

            Vue.axios.post('https://pales.com.tr/wp-admin/admin-ajax.php', formData).then((response) => {
              this.visibleSection = 'mailalert'
              let userData = {
                token: userToken,
                userWasteList: this.userWasteList
              }
              localStorage.setItem('userData', JSON.stringify(userData))
            })
            return;
          }
        });
      }
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/view/pages/Home/index.vue